import { createRootRoute } from "@tanstack/react-router";
import { type TranslationCrumb } from "src/datahandling/hooks/useBreadcrumbs";
import { type LocalizedLabelKey } from "src/datahandling/localization/application.i18n";
import { ErrorPage } from "src/pages/Utility/ErrorPage";
import { NotFoundPage } from "src/pages/Utility/NotFoundPage";
import { RootPage } from "src/pages/Root/RootPage";
import { fonts } from "src/app/infrastructure/fonts";

export const Route = createRootRoute({
	component: RootPage,
	notFoundComponent: NotFoundPage,
	errorComponent: ErrorPage,
	loader: () => {
		return {
			crumb: {
				type: "translation",
				key: ["dashboard"] as unknown as LocalizedLabelKey,
			} satisfies TranslationCrumb,
		};
	},
	head: () => ({
		links: [...fonts],
	}),
});
